var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb m-0"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,class:_vm.itemClass(item)},[(item.link)?_c('span',[_c('router-link',{attrs:{"to":{ name: item.link }}},[_vm._v(_vm._s(item.text))])],1):_c('span',[_vm._v(_vm._s(item.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }